import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indoor-amateur-bootstrap',
  templateUrl: './indoor-amateur-bootstrap.component.html',
  styleUrls: ['./indoor-amateur-bootstrap.component.scss']
})
export class IndoorAmateurBootstrapComponent {
  constructor() {}
}
